/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IAdmission } from 'app/shared/model/admission.model';
import { IEquipmentIP } from 'app/shared/model/equipment-ip.model';
import { IAppointments } from 'app/shared/model/appointments.model';
import { IEquipmentIPCharges } from 'app/shared/model/equipment-ip-charges.model';
import { AllottedByType } from 'app/shared/model/enumerations/allotted-by-type.model';
import { PatientType } from 'app/shared/model/enumerations/patient-type.model';

export interface IEquipmentAllotment {
  id?: string;
  allotmentDate?: number | null;
  releaseDate?: number | null;
  lastupdated?: number | null;
  cursor?: number;
  active?: boolean | null;
  allotmentNotes?: string | null;
  allottedById?: string | null;
  releasedById?: string | null;
  allottedByType?: keyof typeof AllottedByType | null;
  releasedByType?: keyof typeof AllottedByType | null;
  quantity?: string | null;
  allotmentType?: keyof typeof PatientType | null;
  admission?: IAdmission | null;
  equipment?: IEquipmentIP | null;
  appointment?: IAppointments | null;
  equipmentCharge?: IEquipmentIPCharges | null;
}

export const defaultValue: Readonly<IEquipmentAllotment> = {
  active: false,
};
